export function getSubscriptionUrl(userEmail = '', userFirstName = '', userLastName = '') {
  return `https://spiro.ai/lp/buy-spiro?email=${userEmail}&f_name=${userFirstName}&l_name=${userLastName}`;
}

export default {
  getSubscriptionUrl,
};
